import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "card",
  style: {"height":"calc(100vh - 165px)"}
}
const _hoisted_2 = { class: "table-header p-d-flex p-ai-center" }
const _hoisted_3 = {
  id: "search-container",
  class: "p-input-icon-left p-mr-3"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_DataTable, {
      value: _ctx.foreignKeys,
      class: "p-datatable-sm kn-table",
      dataKey: "id",
      filters: _ctx.filters,
      "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters = $event)),
      globalFilterFields: _ctx.metawebForeignKeyTabDescriptor.globalFilterFields,
      responsiveLayout: "stack",
      breakpoint: "600px",
      scrollable: true,
      scrollHeight: _ctx.metawebForeignKeyTabDescriptor.scrollHeight
    }, {
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
      ]),
      header: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_InputText, {
              class: "kn-material-input",
              modelValue: _ctx.filters['global'].value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
              placeholder: _ctx.$t('common.search')
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          class: "kn-truncated",
          field: "name",
          header: _ctx.$t('common.name'),
          key: "name",
          sortable: true
        }, {
          body: _withCtx((slotProps) => [
            _withDirectives(_createVNode("span", null, [
              _createTextVNode(_toDisplayString(slotProps.data.name), 1)
            ], 512), [
              [
                _directive_tooltip,
                slotProps.data.name,
                void 0,
                { top: true }
              ]
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          class: "kn-truncated",
          header: _ctx.$t('metaweb.physicalModel.sourceColumns'),
          sortable: true
        }, {
          body: _withCtx((slotProps) => [
            _withDirectives(_createVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.getColumns(slotProps.data, 'sourceColumns')), 1)
            ], 512), [
              [
                _directive_tooltip,
                _ctx.getColumns(slotProps.data, 'sourceColumns'),
                void 0,
                { top: true }
              ]
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          class: "kn-truncated",
          header: _ctx.$t('metaweb.physicalModel.targetColumns'),
          sortable: true
        }, {
          body: _withCtx((slotProps) => [
            _withDirectives(_createVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.getColumns(slotProps.data, 'destinationColumns')), 1)
            ], 512), [
              [
                _directive_tooltip,
                _ctx.getColumns(slotProps.data, 'destinationColumns'),
                void 0,
                { top: true }
              ]
            ])
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    }, 8, ["value", "filters", "globalFilterFields", "scrollHeight"])
  ]))
}